import { getEasasRestUrl } from "utils/utils";
import { ScadaProps } from "../scadaTypes";

export const IMAGE_UPLOAD_URL = '/EASAS/rest/images/upload';

export function getScadaImageUrl(scadaBackgroundId: number | undefined) {
    if (!scadaBackgroundId) return '';
    return getEasasRestUrl() + "/images/" + scadaBackgroundId;
}

export function showCords(el: React.MouseEvent, isEditMode: boolean) {
    if (el.ctrlKey && isEditMode) {
        const tooltip = document.getElementById('simple-tooltip') as HTMLDivElement;
        const rect = (el.target as Element)!.getBoundingClientRect();

        const contWidth = rect.width;
        const contHeight = rect.height;
        const x = el.clientX,
            y = el.clientY;
        tooltip.style.top = y + 20 + 'px';
        tooltip.style.left = x + 20 + 'px';

        const relX = el.clientX - rect.left;
        const relY = el.clientY - rect.top;
        const pX = ((relX / contWidth) * 100).toFixed(2);
        const pY = ((relY / contHeight) * 100).toFixed(2);

        tooltip.textContent = `X:${pX}%, Y:${pY}%`;
        tooltip.style.display = 'block';
        tooltip.style.position = 'fixed';
    } else if (!el.ctrlKey || !isEditMode) {
        let tooltip = document.getElementById('simple-tooltip') as HTMLDivElement;
        tooltip.style.display = 'none';
    }
}

export const tempId = (data: ScadaProps) => `${data.scadaBackgroundId}-${data.refreshRate}-${data.maxDelayTimeUnit}-${data.maxDelayTime}`